module.exports = __webpack_public_path__ + "static/img/grow2.c559ed3e.png";